import axios from 'axios';

import { cioanalytics } from '@/main'; // adjust path if needed

const url = process.env.VUE_APP_API_BASE_URL;

function list(params) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/user/subscriptions/team`, params, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/user/subscriptions/team <br>`;
                throw new Error(errorInfo);
            }

            return res;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function add(params) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/user/subscriptions/team/add`, params, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/user/subscriptions/team/add <br>`;
                throw new Error(errorInfo);
            }
            
            if (res.hasOwnProperty('data') && res.data.customer_io) {
                cioanalytics.track('sub-user-add', {
                    ...res.data.customer_io
                });
            }

            return res;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function edit(params) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/user/subscriptions/team/edit`, params, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/user/subscriptions/team/edit <br>`;
                throw new Error(errorInfo);
            }
            return res;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function remove(params) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/user/subscriptions/team/remove`, params, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/user/subscriptions/team/remove <br>`;
                throw new Error(errorInfo);
            }
            return res;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

function reinstate(params) {
    const options = {
        headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        },
    };

    return axios
        .post(`${url}/user/subscriptions/team/reinstate`, params, options)
        .then((res) => {
            if (res.hasOwnProperty('data') && res.data.error) {
                let errorInfo = '';
                for (const [key, value] of Object.entries(res.data)) {
                    errorInfo += `<br> ${key}: ${value} <br>`;
                }
                errorInfo += `<br> API LINK: ${url}/user/subscriptions/team/reinstate <br>`;
                throw new Error(errorInfo);
            }
            return res;
        })
        .catch((err) => {
            throw new Error(err.stack);
        });
}

export default {
    list,
    add,
    edit,
    remove,
    reinstate,
};